import { render, staticRenderFns } from "./ScaniaBodybuilderSymbols.vue?vue&type=template&id=42e08515&"
import script from "./ScaniaBodybuilderSymbols.vue?vue&type=script&lang=js&"
export * from "./ScaniaBodybuilderSymbols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports